// translations.js

export const translations = {

  en: {
        step1: "Step 1 of 2",
        step2: "Step 2 of 2",
        title1: "Help Improve Our Extension",
        desc1:
          "Our extension does not automatically collect user data. Help us better understand how the extension is used by sharing some technical data anonymously.",
        collect: "What we would collect:",
        collect1: "UID (a random code created at installation)",
        collect2: "Extension version",
        collect3: "Date of installation",
        collect4: "Number of times the download button was pressed",
        collect5: "Settings excluding the contents of: URL filter, folder prefix, and file prefix",
        allow:
          "Allow one-time anonymous collection of technical data",
  
        title2:
          "We have a few questions for you (all are optional)",
  
        browser: "What is your browser?",
        os: "What is your operating system?",
        Windows_10_or_older: "Windows 10 or older",
        speed: "What is your web connection speed?",
        Less_than_1_Mbps:"Less than 1 Mbps",
        More_than_100_Mbps: "More than 100 Mbps",
        freq:
          "How frequently do you use the extension?",
        Daily: "Daily",
        Weekly: "Weekly",
        Monthly: "Monthly",
        Rarely: "Rarely",
        purpose:
          "What do you use the extension for?",
        translation:
          "Have you encountered any translation issues in the extension, user guide, or website?",
        bugs:
          "Have you encountered any bugs? If so, what were they?",
        improve:
          "What can we improve?",
        side:
          "Did you know that you can open the extension as a side window?",
        convert:
          "Did you know that you can automatically convert image formats?",
        rate:
          "How would you rate us?",
        anything:
          "Anything else?",
  
        submit:
          "Submit Feedback",
  
        thanks:
          "Thank You",
  
        done:
          "Thank you for your feedback. You installed the extension on",
  
        pressed:
          "and pressed the download button",
  
        times:
          "times.",
  
        share:
          "Share the Extension",
        Other:
        "Other",
        no:
          "Don't want to answer",
  
        yes:
          "Yes",
  
        no2:
          "No",
  
        na:
          "N/A",
        Share_extension:
          "Share extension",
        Rate_us:
          "Rate us"
      },
ar: {
step1: "الخطوة 1 من 2",
step2: "الخطوة 2 من 2",
title1: "ساعدنا في تحسين الإضافة",
desc1: "إضافتنا لا تجمع بيانات المستخدم تلقائيًا. ساعدنا على فهم كيفية استخدامها من خلال مشاركة بيانات تقنية مجهولة.",
collect: "ما الذي سنجمعه:",
collect1: "معرّف المستخدم (رمز عشوائي عند التثبيت)",
collect2: "إصدار الإضافة",
collect3: "تاريخ التثبيت",
collect4: "عدد مرات الضغط على زر التحميل",
collect5: "الإعدادات باستثناء محتوى فلاتر الروابط والمجلد والملفات",
allow: "السماح بجمع بيانات تقنية مجهولة مرة واحدة",

title2: "لدينا بعض الأسئلة (اختيارية)",

browser: "ما هو المتصفح؟",
os: "ما هو نظام التشغيل؟",
Windows_10_or_older: "ويندوز 10 أو أقدم",
speed: "ما سرعة الإنترنت لديك؟",
Less_than_1_Mbps: "أقل من 1 Mbps",
More_than_100_Mbps: "أكثر من 100 Mbps",
freq: "كم مرة تستخدم الإضافة؟",
Daily: "يوميًا",
Weekly: "أسبوعيًا",
Monthly: "شهريًا",
Rarely: "نادرًا",
purpose: "لماذا تستخدم الإضافة؟",
translation: "هل واجهت مشاكل ترجمة؟",
bugs: "هل واجهت أخطاء؟",
improve: "كيف يمكننا التحسين؟",
side: "هل تعلم أنه يمكنك فتح الإضافة كنافذة جانبية؟",
convert: "هل تعلم أنه يمكنك تحويل الصور تلقائيًا؟",
rate: "كيف تقيمنا؟",
anything: "أي شيء آخر؟",
submit: "إرسال",
thanks: "شكرًا لك",
done: "شكرًا لملاحظاتك. لقد ثبت الإضافة في",
pressed: "وضغطت زر التحميل",
times: "مرات.",
share: "مشاركة الإضافة",
Other: "أخرى",
no: "لا أريد الإجابة",
yes: "نعم",
no2: "لا",
na: "غير متاح",
Share_extension: "مشاركة الإضافة",
Rate_us: "قيمنا"
},

am: {
step1: "ደረጃ 1 ከ 2",
step2: "ደረጃ 2 ከ 2",
title1: "ተጨማሪያችንን ለማሻሻል እርዳን",
desc1: "ተጨማሪያችን በራሱ የተጠቃሚ ውሂብ አይሰበስብም። የተለያዩ ቴክኒካዊ ውሂብ በማካፈል እርዳን።",
collect: "የምንሰበስበው:",
collect1: "UID",
collect2: "የተጨማሪያ ስሪት",
collect3: "የተጫነበት ቀን",
collect4: "የዳውንሎድ ቁጥር",
collect5: "ቅንብሮች (URL ፍልተር እና ፎልደር ብቻ አይካተቱም)",
allow: "አንድ ጊዜ የማይታወቅ ውሂብ ፍቀድ",

title2: "ጥያቄዎች",

browser: "መርምሪያ",
os: "ስርዓተ ክወና",
Windows_10_or_older: "Windows 10 ወይም ከዚያ በፊት",
speed: "የኢንተርኔት ፍጥነት",
Less_than_1_Mbps: "ከ1 Mbps በታች",
More_than_100_Mbps: "ከ100 Mbps በላይ",
freq: "ምን ያህል ትጠቀማለህ?",
Daily: "በየቀኑ",
Weekly: "በሳምንት",
Monthly: "በወር",
Rarely: "አልፎ አልፎ",
purpose: "ለምን ትጠቀማለህ?",
translation: "የትርጉም ችግር አለ?",
bugs: "ችግር አለ?",
improve: "ምን እንሻለን?",
side: "እንደ side panel ማድረግ ትችላለህ",
convert: "ምስል መቀየር ትችላለህ",
rate: "እንዴት ትገምጻለህ?",
anything: "ሌላ ነገር",
submit: "ላክ",
thanks: "እናመሰግናለን",
done: "እናመሰግናለን በ",
pressed: "አውርድ ተጭኗል",
times: "ጊዜ",
share: "አካፍል",
Other: "ሌላ",
no: "መልስ አልፈልግም",
yes: "አዎ",
no2: "አይ",
na: "የለም",
Share_extension: "አካፍል",
Rate_us: "ይገምጹን"
},

bg: {
step1: "Стъпка 1 от 2",
step2: "Стъпка 2 от 2",
title1: "Помогнете ни да подобрим разширението",
desc1: "Нашето разширение не събира автоматично потребителски данни. Помогнете ни като споделите анонимни технически данни.",
collect: "Какво събираме:",
collect1: "UID",
collect2: "Версия",
collect3: "Дата на инсталация",
collect4: "Брой изтегляния",
collect5: "Настройки (без URL филтър и др.)",
allow: "Позволи еднократно събиране на данни",

title2: "Няколко въпроса",

browser: "Браузър",
os: "Операционна система",
Windows_10_or_older: "Windows 10 или по-стар",
speed: "Скорост на интернет",
Less_than_1_Mbps: "Под 1 Mbps",
More_than_100_Mbps: "Над 100 Mbps",
freq: "Колко често го използвате?",
Daily: "Ежедневно",
Weekly: "Седмично",
Monthly: "Месечно",
Rarely: "Рядко",
purpose: "За какво го използвате?",
translation: "Проблеми с превод?",
bugs: "Бъгове?",
improve: "Подобрения?",
side: "Знаете ли за страничен панел?",
convert: "Автоматично конвертиране?",
rate: "Оценка",
anything: "Друго",
submit: "Изпрати",
thanks: "Благодаря",
done: "Инсталирано на",
pressed: "натиснат бутон за изтегляне",
times: "пъти",
share: "Сподели",
Other: "Друго",
no: "Не желая да отговоря",
yes: "Да",
no2: "Не",
na: "Н/Д",
Share_extension: "Сподели",
Rate_us: "Оцени ни"
},

bn: {
step1: "ধাপ ১ / ২",
step2: "ধাপ ২ / ২",
title1: "আমাদের এক্সটেনশন উন্নত করতে সাহায্য করুন",
desc1: "আমাদের এক্সটেনশন স্বয়ংক্রিয়ভাবে ডেটা সংগ্রহ করে না। কিছু অ্যানোনিমাস ডেটা শেয়ার করুন।",
collect: "আমরা যা সংগ্রহ করব:",
collect1: "UID",
collect2: "ভার্সন",
collect3: "ইনস্টল তারিখ",
collect4: "ডাউনলোড সংখ্যা",
collect5: "সেটিংস (ফিল্টার বাদে)",
allow: "একবারের জন্য অনুমতি দিন",

title2: "কিছু প্রশ্ন",

browser: "ব্রাউজার",
os: "অপারেটিং সিস্টেম",
Windows_10_or_older: "Windows 10 বা পুরোনো",
speed: "ইন্টারনেট স্পিড",
Less_than_1_Mbps: "১ Mbps এর কম",
More_than_100_Mbps: "১০০ Mbps এর বেশি",
freq: "কতবার ব্যবহার করেন?",
Daily: "প্রতিদিন",
Weekly: "সাপ্তাহিক",
Monthly: "মাসিক",
Rarely: "কখনও কখনও",
purpose: "কেন ব্যবহার করেন?",
translation: "অনুবাদ সমস্যা?",
bugs: "বাগ?",
improve: "উন্নতি?",
side: "সাইড প্যানেল?",
convert: "ছবি কনভার্ট?",
rate: "রেটিং",
anything: "আর কিছু?",
submit: "জমা দিন",
thanks: "ধন্যবাদ",
done: "ধন্যবাদ, ইনস্টল করেছেন",
pressed: "ডাউনলোড চাপা হয়েছে",
times: "বার",
share: "শেয়ার করুন",
Other: "অন্যান্য",
no: "উত্তর দিতে চাই না",
yes: "হ্যাঁ",
no2: "না",
na: "N/A",
Share_extension: "শেয়ার",
Rate_us: "রেট দিন"
},

ca: {
step1: "Pas 1 de 2",
step2: "Pas 2 de 2",
title1: "Ajuda'ns a millorar l'extensió",
desc1: "No recollim dades personals automàticament. Comparteix dades tècniques anònimes.",
collect: "Què recollim:",
collect1: "UID",
collect2: "Versió",
collect3: "Data d'instal·lació",
collect4: "Clics de descàrrega",
collect5: "Configuracions (sense filtres sensibles)",
allow: "Permet recollida única",

title2: "Algunes preguntes",

browser: "Navegador",
os: "Sistema operatiu",
Windows_10_or_older: "Windows 10 o anterior",
speed: "Velocitat d'internet",
Less_than_1_Mbps: "Menys d'1 Mbps",
More_than_100_Mbps: "Més de 100 Mbps",
freq: "Freqüència d'ús",
Daily: "Diari",
Weekly: "Setmanal",
Monthly: "Mensual",
Rarely: "Rarament",
purpose: "Ús",
translation: "Problemes de traducció?",
bugs: "Errors?",
improve: "Millores?",
side: "Saps del panell lateral?",
convert: "Conversió automàtica?",
rate: "Valora'ns",
anything: "Altres",
submit: "Enviar",
thanks: "Gràcies",
done: "Instal·lat el",
pressed: "clics de descàrrega",
times: "vegades",
share: "Comparteix",
Other: "Altres",
no: "No vull respondre",
yes: "Sí",
no2: "No",
na: "N/A",
Share_extension: "Comparteix",
Rate_us: "Valora'ns"
},

cs: {
step1: "Krok 1 z 2",
step2: "Krok 2 z 2",
title1: "Pomozte nám vylepšit rozšíření",
desc1: "Neshromažďujeme automaticky osobní data. Pomozte sdílením anonymních dat.",
collect: "Co sbíráme:",
collect1: "UID",
collect2: "Verze",
collect3: "Datum instalace",
collect4: "Počet stažení",
collect5: "Nastavení (bez citlivých částí)",
allow: "Jednorázový souhlas",

title2: "Otázky",

browser: "Prohlížeč",
os: "Operační systém",
Windows_10_or_older: "Windows 10 nebo starší",
speed: "Rychlost internetu",
Less_than_1_Mbps: "Méně než 1 Mbps",
More_than_100_Mbps: "Více než 100 Mbps",
freq: "Jak často používáte?",
Daily: "Denně",
Weekly: "Týdně",
Monthly: "Měsíčně",
Rarely: "Zřídka",
purpose: "Použití",
translation: "Problémy s překladem?",
bugs: "Bugy?",
improve: "Zlepšení?",
side: "Postranní panel?",
convert: "Konverze obrázků?",
rate: "Hodnocení",
anything: "Cokoliv",
submit: "Odeslat",
thanks: "Děkujeme",
done: "Instalováno",
pressed: "kliknutí",
times: "krát",
share: "Sdílet",
Other: "Jiné",
no: "Nechci odpovědět",
yes: "Ano",
no2: "Ne",
na: "N/A",
Share_extension: "Sdílet",
Rate_us: "Ohodnoťte nás"
},

da: {
step1: "Trin 1 af 2",
step2: "Trin 2 af 2",
title1: "Hjælp os med at forbedre udvidelsen",
desc1: "Vi indsamler ikke automatisk data. Del anonym teknisk data.",
collect: "Vi indsamler:",
collect1: "UID",
collect2: "Version",
collect3: "Installationsdato",
collect4: "Downloads",
collect5: "Indstillinger (uden følsomme filtre)",
allow: "Tillad engangsdata",

title2: "Spørgsmål",

browser: "Browser",
os: "OS",
Windows_10_or_older: "Windows 10 eller ældre",
speed: "Internet hastighed",
Less_than_1_Mbps: "Under 1 Mbps",
More_than_100_Mbps: "Over 100 Mbps",
freq: "Brug",
Daily: "Dagligt",
Weekly: "Ugentligt",
Monthly: "Månedligt",
Rarely: "Sjældent",
purpose: "Formål",
translation: "Oversættelsesproblemer?",
bugs: "Fejl?",
improve: "Forbedringer?",
side: "Sidepanel?",
convert: "Konvertering?",
rate: "Bedøm",
anything: "Andet",
submit: "Send",
thanks: "Tak",
done: "Installeret",
pressed: "downloads",
times: "gange",
share: "Del",
Other: "Andet",
no: "Vil ikke svare",
yes: "Ja",
no2: "Nej",
na: "N/A",
Share_extension: "Del",
Rate_us: "Bedøm os"
},

de: {
step1: "Schritt 1 von 2",
step2: "Schritt 2 von 2",
title1: "Hilf uns, die Erweiterung zu verbessern",
desc1: "Wir sammeln keine persönlichen Daten. Teile anonyme technische Daten.",
collect: "Wir sammeln:",
collect1: "UID",
collect2: "Version",
collect3: "Installationsdatum",
collect4: "Download-Anzahl",
collect5: "Einstellungen (ohne sensible Filter)",
allow: "Einmalige Freigabe",

title2: "Fragen",

browser: "Browser",
os: "Betriebssystem",
Windows_10_or_older: "Windows 10 oder älter",
speed: "Internetgeschwindigkeit",
Less_than_1_Mbps: "Unter 1 Mbps",
More_than_100_Mbps: "Über 100 Mbps",
freq: "Nutzung",
Daily: "Täglich",
Weekly: "Wöchentlich",
Monthly: "Monatlich",
Rarely: "Selten",
purpose: "Verwendung",
translation: "Übersetzungsprobleme?",
bugs: "Fehler?",
improve: "Verbesserungen?",
side: "Seitenpanel?",
convert: "Konvertierung?",
rate: "Bewertung",
anything: "Sonstiges",
submit: "Senden",
thanks: "Danke",
done: "Installiert am",
pressed: "Downloads",
times: "Mal",
share: "Teilen",
Other: "Andere",
no: "Keine Antwort",
yes: "Ja",
no2: "Nein",
na: "N/A",
Share_extension: "Teilen",
Rate_us: "Bewerten"
},

el: {
step1: "Βήμα 1 από 2",
step2: "Βήμα 2 από 2",
title1: "Βοήθησέ μας να βελτιώσουμε την επέκταση",
desc1: "Δεν συλλέγουμε αυτόματα προσωπικά δεδομένα.",
collect: "Τι συλλέγουμε:",
collect1: "UID",
collect2: "Έκδοση",
collect3: "Ημερομηνία εγκατάστασης",
collect4: "Κλικ λήψης",
collect5: "Ρυθμίσεις (χωρίς φίλτρα)",
allow: "Μία φορά συγκατάθεση",

title2: "Ερωτήσεις",

browser: "Browser",
os: "Λειτουργικό",
Windows_10_or_older: "Windows 10 ή παλαιότερο",
speed: "Ταχύτητα internet",
Less_than_1_Mbps: "Κάτω από 1 Mbps",
More_than_100_Mbps: "Πάνω από 100 Mbps",
freq: "Συχνότητα",
Daily: "Καθημερινά",
Weekly: "Εβδομαδιαία",
Monthly: "Μηνιαία",
Rarely: "Σπάνια",
purpose: "Χρήση",
translation: "Προβλήματα μετάφρασης;",
bugs: "Σφάλματα;",
improve: "Βελτιώσεις;",
side: "Πλευρικό panel;",
convert: "Μετατροπή εικόνων;",
rate: "Αξιολόγηση",
anything: "Άλλο",
submit: "Υποβολή",
thanks: "Ευχαριστούμε",
done: "Εγκατάσταση",
pressed: "λήψεις",
times: "φορές",
share: "Κοινοποίηση",
Other: "Άλλο",
no: "Δεν θέλω να απαντήσω",
yes: "Ναι",
no2: "Όχι",
na: "N/A",
Share_extension: "Κοινοποίηση",
Rate_us: "Βαθμολογήστε μας"
},

es: {
step1: "Paso 1 de 2",
step2: "Paso 2 de 2",
title1: "Ayúdanos a mejorar la extensión",
desc1: "No recopilamos datos personales automáticamente. Comparte datos técnicos anónimos.",
collect: "Qué recopilamos:",
collect1: "UID",
collect2: "Versión",
collect3: "Fecha de instalación",
collect4: "Clicks de descarga",
collect5: "Configuraciones (sin filtros sensibles)",
allow: "Permitir una vez",

title2: "Preguntas",

browser: "Navegador",
os: "Sistema operativo",
Windows_10_or_older: "Windows 10 o anterior",
speed: "Velocidad de internet",
Less_than_1_Mbps: "Menos de 1 Mbps",
More_than_100_Mbps: "Más de 100 Mbps",
freq: "Frecuencia",
Daily: "Diario",
Weekly: "Semanal",
Monthly: "Mensual",
Rarely: "Rara vez",
purpose: "Uso",
translation: "Problemas de traducción?",
bugs: "Errores?",
improve: "Mejoras?",
side: "Panel lateral?",
convert: "Conversión?",
rate: "Califícanos",
anything: "Otro",
submit: "Enviar",
thanks: "Gracias",
done: "Instalado en",
pressed: "clics de descarga",
times: "veces",
share: "Compartir",
Other: "Otro",
no: "No responder",
yes: "Sí",
no2: "No",
na: "N/A",
Share_extension: "Compartir",
Rate_us: "Califícanos"
},
et: {
step1: "Samm 1/2",
step2: "Samm 2/2",
title1: "Aita meil laiendust parandada",
desc1: "Me ei kogu automaatselt isikuandmeid. Jaga anonüümseid tehnilisi andmeid.",
collect: "Mida kogume:",
collect1: "UID",
collect2: "Versioon",
collect3: "Paigaldamise kuupäev",
collect4: "Allalaadimiste arv",
collect5: "Seaded (välja arvatud tundlikud filtrid)",
allow: "Luba ühekordne kogumine",

title2: "Mõned küsimused",

browser: "Brauser",
os: "Operatsioonisüsteem",
Windows_10_or_older: "Windows 10 või vanem",
speed: "Interneti kiirus",
Less_than_1_Mbps: "Alla 1 Mbps",
More_than_100_Mbps: "Üle 100 Mbps",
freq: "Kasutamise sagedus",
Daily: "Igapäevaselt",
Weekly: "Iganädalaselt",
Monthly: "Igakuiselt",
Rarely: "Harva",
purpose: "Kasutus",
translation: "Tõlkeprobleemid?",
bugs: "Vead?",
improve: "Parandused?",
side: "Külgpaneel?",
convert: "Pildi konvertimine?",
rate: "Hinda meid",
anything: "Midagi muud",
submit: "Saada",
thanks: "Aitäh",
done: "Paigaldatud",
pressed: "allalaadimised",
times: "korda",
share: "Jaga",
Other: "Muu",
no: "Ei soovi vastata",
yes: "Jah",
no2: "Ei",
na: "N/A",
Share_extension: "Jaga",
Rate_us: "Hinda meid"
},

fa: {
step1: "مرحله ۱ از ۲",
step2: "مرحله ۲ از ۲",
title1: "به ما در بهبود افزونه کمک کنید",
desc1: "ما به صورت خودکار داده شخصی جمع‌آوری نمی‌کنیم. داده فنی ناشناس را به اشتراک بگذارید.",
collect: "چه چیزی جمع‌آوری می‌کنیم:",
collect1: "شناسه کاربر",
collect2: "نسخه",
collect3: "تاریخ نصب",
collect4: "تعداد دانلود",
collect5: "تنظیمات (بدون فیلتر حساس)",
allow: "اجازه یک‌باره",

title2: "چند سؤال",

browser: "مرورگر",
os: "سیستم عامل",
Windows_10_or_older: "ویندوز 10 یا قدیمی‌تر",
speed: "سرعت اینترنت",
Less_than_1_Mbps: "کمتر از 1 Mbps",
More_than_100_Mbps: "بیشتر از 100 Mbps",
freq: "میزان استفاده",
Daily: "روزانه",
Weekly: "هفتگی",
Monthly: "ماهانه",
Rarely: "به ندرت",
purpose: "کاربرد",
translation: "مشکل ترجمه؟",
bugs: "باگ؟",
improve: "بهبودها؟",
side: "پنل کناری؟",
convert: "تبدیل تصویر؟",
rate: "امتیاز دهید",
anything: "سایر موارد",
submit: "ارسال",
thanks: "متشکریم",
done: "نصب شده در",
pressed: "تعداد دانلود",
times: "بار",
share: "اشتراک‌گذاری",
Other: "سایر",
no: "نمی‌خواهم پاسخ دهم",
yes: "بله",
no2: "خیر",
na: "نامشخص",
Share_extension: "اشتراک",
Rate_us: "امتیاز دهید"
},

fi: {
step1: "Vaihe 1/2",
step2: "Vaihe 2/2",
title1: "Auta meitä parantamaan laajennusta",
desc1: "Emme kerää automaattisesti henkilötietoja. Jaa anonyymejä teknisiä tietoja.",
collect: "Mitä keräämme:",
collect1: "UID",
collect2: "Versio",
collect3: "Asennuspäivä",
collect4: "Latauskerrat",
collect5: "Asetukset (ei herkkiä suodattimia)",
allow: "Salli kertaluonteinen keräys",

title2: "Kysymyksiä",

browser: "Selain",
os: "Käyttöjärjestelmä",
Windows_10_or_older: "Windows 10 tai vanhempi",
speed: "Internet-nopeus",
Less_than_1_Mbps: "Alle 1 Mbps",
More_than_100_Mbps: "Yli 100 Mbps",
freq: "Käyttötiheys",
Daily: "Päivittäin",
Weekly: "Viikoittain",
Monthly: "Kuukausittain",
Rarely: "Harvoin",
purpose: "Käyttö",
translation: "Käännösongelmia?",
bugs: "Bugeja?",
improve: "Parannuksia?",
side: "Sivupaneeli?",
convert: "Kuvamuunnos?",
rate: "Arvioi",
anything: "Muuta",
submit: "Lähetä",
thanks: "Kiitos",
done: "Asennettu",
pressed: "latausta",
times: "kertaa",
share: "Jaa",
Other: "Muu",
no: "En halua vastata",
yes: "Kyllä",
no2: "Ei",
na: "N/A",
Share_extension: "Jaa",
Rate_us: "Arvioi"
},

fil: {
step1: "Hakbang 1 ng 2",
step2: "Hakbang 2 ng 2",
title1: "Tulungan kaming pagandahin ang extension",
desc1: "Hindi kami awtomatikong nangongolekta ng personal na data.",
collect: "Kinokolekta namin:",
collect1: "UID",
collect2: "Bersyon",
collect3: "Petsa ng pag-install",
collect4: "Bilang ng downloads",
collect5: "Settings (hindi kasama ang sensitive filters)",
allow: "Isang beses na pahintulot",

title2: "Ilang tanong",

browser: "Browser",
os: "Operating system",
Windows_10_or_older: "Windows 10 o mas luma",
speed: "Internet speed",
Less_than_1_Mbps: "Mas mababa sa 1 Mbps",
More_than_100_Mbps: "Higit sa 100 Mbps",
freq: "Gaano kadalas?",
Daily: "Araw-araw",
Weekly: "Lingguhan",
Monthly: "Buwan-buwan",
Rarely: "Bihira",
purpose: "Gamit",
translation: "Isyu sa translation?",
bugs: "Bugs?",
improve: "Pagbuti?",
side: "Side panel?",
convert: "Image convert?",
rate: "I-rate",
anything: "Iba pa",
submit: "Ipadala",
thanks: "Salamat",
done: "Na-install noong",
pressed: "beses na download",
times: "beses",
share: "I-share",
Other: "Iba pa",
no: "Ayaw sumagot",
yes: "Oo",
no2: "Hindi",
na: "N/A",
Share_extension: "I-share",
Rate_us: "I-rate kami"
},

fr: {
step1: "Étape 1 sur 2",
step2: "Étape 2 sur 2",
title1: "Aidez-nous à améliorer l’extension",
desc1: "Nous ne collectons pas automatiquement de données personnelles.",
collect: "Nous collectons :",
collect1: "UID",
collect2: "Version",
collect3: "Date d’installation",
collect4: "Nombre de téléchargements",
collect5: "Paramètres (hors filtres sensibles)",
allow: "Autoriser une collecte unique",

title2: "Questions",

browser: "Navigateur",
os: "Système d’exploitation",
Windows_10_or_older: "Windows 10 ou plus ancien",
speed: "Vitesse Internet",
Less_than_1_Mbps: "Moins de 1 Mbps",
More_than_100_Mbps: "Plus de 100 Mbps",
freq: "Fréquence d’utilisation",
Daily: "Quotidien",
Weekly: "Hebdomadaire",
Monthly: "Mensuel",
Rarely: "Rarement",
purpose: "Utilisation",
translation: "Problèmes de traduction ?",
bugs: "Bugs ?",
improve: "Améliorations ?",
side: "Panneau latéral ?",
convert: "Conversion d’images ?",
rate: "Évaluez-nous",
anything: "Autre",
submit: "Envoyer",
thanks: "Merci",
done: "Installé le",
pressed: "téléchargements",
times: "fois",
share: "Partager",
Other: "Autre",
no: "Ne pas répondre",
yes: "Oui",
no2: "Non",
na: "N/A",
Share_extension: "Partager",
Rate_us: "Évaluez-nous"
},

gu: {
step1: "પગલું 1 / 2",
step2: "પગલું 2 / 2",
title1: "એક્સટેન્શન સુધારવામાં મદદ કરો",
desc1: "અમે આપમેળે વ્યક્તિગત ડેટા એકત્રિત કરતા નથી.",
collect: "અમે શું એકત્ર કરીએ છીએ:",
collect1: "UID",
collect2: "વર્ઝન",
collect3: "ઇન્સ્ટોલ તારીખ",
collect4: "ડાઉનલોડ સંખ્યા",
collect5: "સેટિંગ્સ (સેન્સિટિવ ફિલ્ટર વગર)",
allow: "એક વખતની મંજૂરી",

title2: "કેટલાક પ્રશ્નો",

browser: "બ્રાઉઝર",
os: "ઓપરેટિંગ સિસ્ટમ",
Windows_10_or_older: "Windows 10 અથવા જૂનું",
speed: "ઇન્ટરનેટ સ્પીડ",
Less_than_1_Mbps: "1 Mbps થી ઓછું",
More_than_100_Mbps: "100 Mbps થી વધુ",
freq: "વપરાશ આવર્તન",
Daily: "દરરોજ",
Weekly: "અઠવાડિક",
Monthly: "માસિક",
Rarely: "ક્યારેક",
purpose: "ઉપયોગ",
translation: "ટ્રાન્સલેશન સમસ્યા?",
bugs: "બગ્સ?",
improve: "સુધારા?",
side: "સાઇડ પેનલ?",
convert: "ઈમેજ કન્વર્ટ?",
rate: "અમને રેટ કરો",
anything: "અન્ય",
submit: "સબમિટ",
thanks: "આભાર",
done: "ઇન્સ્ટોલ થયું",
pressed: "ડાઉનલોડ્સ",
times: "વખત",
share: "શેર કરો",
Other: "અન્ય",
no: "જવાબ નથી આપવો",
yes: "હા",
no2: "ના",
na: "લાગુ નથી",
Share_extension: "શેર",
Rate_us: "રેટ કરો"
},

he: {
step1: "שלב 1 מתוך 2",
step2: "שלב 2 מתוך 2",
title1: "עזור לנו לשפר את התוסף",
desc1: "אנחנו לא אוספים נתונים אישיים באופן אוטומטי.",
collect: "מה נאסוף:",
collect1: "מזהה משתמש",
collect2: "גרסה",
collect3: "תאריך התקנה",
collect4: "מספר הורדות",
collect5: "הגדרות (ללא פילטרים רגישים)",
allow: "אישור חד פעמי",

title2: "שאלות",

browser: "דפדפן",
os: "מערכת הפעלה",
Windows_10_or_older: "Windows 10 או ישן יותר",
speed: "מהירות אינטרנט",
Less_than_1_Mbps: "פחות מ-1 Mbps",
More_than_100_Mbps: "יותר מ-100 Mbps",
freq: "תדירות שימוש",
Daily: "יומי",
Weekly: "שבועי",
Monthly: "חודשי",
Rarely: "לעיתים רחוקות",
purpose: "שימוש",
translation: "בעיות תרגום?",
bugs: "באגים?",
improve: "שיפורים?",
side: "פאנל צד?",
convert: "המרת תמונות?",
rate: "דרג אותנו",
anything: "משהו נוסף",
submit: "שלח",
thanks: "תודה",
done: "הותקן ב",
pressed: "לחיצות הורדה",
times: "פעמים",
share: "שתף",
Other: "אחר",
no: "לא רוצה לענות",
yes: "כן",
no2: "לא",
na: "לא זמין",
Share_extension: "שתף",
Rate_us: "דרג אותנו"
},

hi: {
step1: "चरण 1 / 2",
step2: "चरण 2 / 2",
title1: "एक्सटेंशन सुधारने में मदद करें",
desc1: "हम स्वचालित रूप से व्यक्तिगत डेटा एकत्र नहीं करते हैं।",
collect: "हम क्या एकत्र करते हैं:",
collect1: "UID",
collect2: "संस्करण",
collect3: "इंस्टॉल तिथि",
collect4: "डाउनलोड संख्या",
collect5: "सेटिंग्स (संवेदनशील फ़िल्टर छोड़कर)",
allow: "एक बार अनुमति दें",

title2: "कुछ प्रश्न",

browser: "ब्राउज़र",
os: "ऑपरेटिंग सिस्टम",
Windows_10_or_older: "Windows 10 या पुराना",
speed: "इंटरनेट स्पीड",
Less_than_1_Mbps: "1 Mbps से कम",
More_than_100_Mbps: "100 Mbps से अधिक",
freq: "उपयोग आवृत्ति",
Daily: "दैनिक",
Weekly: "साप्ताहिक",
Monthly: "मासिक",
Rarely: "कभी-कभी",
purpose: "उपयोग",
translation: "अनुवाद समस्या?",
bugs: "बग?",
improve: "सुधार?",
side: "साइड पैनल?",
convert: "इमेज कन्वर्ट?",
rate: "रेट करें",
anything: "अन्य",
submit: "सबमिट",
thanks: "धन्यवाद",
done: "इंस्टॉल किया गया",
pressed: "डाउनलोड",
times: "बार",
share: "शेयर करें",
Other: "अन्य",
no: "उत्तर नहीं देना चाहता",
yes: "हाँ",
no2: "नहीं",
na: "N/A",
Share_extension: "शेयर",
Rate_us: "रेट करें"
},

hr: {
step1: "Korak 1 od 2",
step2: "Korak 2 od 2",
title1: "Pomozite nam poboljšati ekstenziju",
desc1: "Ne prikupljamo osobne podatke automatski.",
collect: "Što prikupljamo:",
collect1: "UID",
collect2: "Verzija",
collect3: "Datum instalacije",
collect4: "Broj preuzimanja",
collect5: "Postavke (bez osjetljivih filtera)",
allow: "Jednokratno dopuštenje",

title2: "Pitanja",

browser: "Preglednik",
os: "Operativni sustav",
Windows_10_or_older: "Windows 10 ili stariji",
speed: "Brzina interneta",
Less_than_1_Mbps: "Manje od 1 Mbps",
More_than_100_Mbps: "Više od 100 Mbps",
freq: "Učestalost",
Daily: "Dnevno",
Weekly: "Tjedno",
Monthly: "Mjesečno",
Rarely: "Rijetko",
purpose: "Upotreba",
translation: "Problemi s prijevodom?",
bugs: "Greške?",
improve: "Poboljšanja?",
side: "Bočni panel?",
convert: "Pretvaranje slika?",
rate: "Ocijenite nas",
anything: "Ostalo",
submit: "Pošalji",
thanks: "Hvala",
done: "Instalirano",
pressed: "preuzimanja",
times: "puta",
share: "Podijeli",
Other: "Ostalo",
no: "Ne želim odgovoriti",
yes: "Da",
no2: "Ne",
na: "N/A",
Share_extension: "Podijeli",
Rate_us: "Ocijeni nas"
},

hu: {
step1: "1. lépés / 2",
step2: "2. lépés / 2",
title1: "Segíts fejleszteni a bővítményt",
desc1: "Nem gyűjtünk automatikusan személyes adatokat.",
collect: "Mit gyűjtünk:",
collect1: "UID",
collect2: "Verzió",
collect3: "Telepítés dátuma",
collect4: "Letöltések száma",
collect5: "Beállítások (érzékeny szűrők nélkül)",
allow: "Egyszeri engedély",

title2: "Kérdések",

browser: "Böngésző",
os: "Operációs rendszer",
Windows_10_or_older: "Windows 10 vagy régebbi",
speed: "Internet sebesség",
Less_than_1_Mbps: "1 Mbps alatt",
More_than_100_Mbps: "100 Mbps felett",
freq: "Használat",
Daily: "Naponta",
Weekly: "Hetente",
Monthly: "Havonta",
Rarely: "Ritkán",
purpose: "Használat",
translation: "Fordítási probléma?",
bugs: "Hibák?",
improve: "Fejlesztések?",
side: "Oldalsáv?",
convert: "Képkonvertálás?",
rate: "Értékelj minket",
anything: "Egyéb",
submit: "Küldés",
thanks: "Köszönjük",
done: "Telepítve",
pressed: "letöltések",
times: "alkalom",
share: "Megosztás",
Other: "Egyéb",
no: "Nem válaszolok",
yes: "Igen",
no2: "Nem",
na: "N/A",
Share_extension: "Megosztás",
Rate_us: "Értékelj minket"
},
id: {
  step1: "Langkah 1 dari 2",
  step2: "Langkah 2 dari 2",
  title1: "Bantu Tingkatkan Ekstensi Kami",
  desc1:
    "Ekstensi kami tidak secara otomatis mengumpulkan data pengguna. Bantu kami memahami penggunaan dengan membagikan data teknis secara anonim.",
  collect: "Apa yang akan kami kumpulkan:",
  collect1: "UID (kode acak saat instalasi)",
  collect2: "Versi ekstensi",
  collect3: "Tanggal instalasi",
  collect4: "Jumlah klik tombol unduh",
  collect5: "Pengaturan kecuali URL filter, prefix folder, dan prefix file",
  allow: "Izinkan pengumpulan data teknis anonim satu kali",

  title2: "Kami punya beberapa pertanyaan untuk Anda (opsional)",

  browser: "Apa browser Anda?",
  os: "Apa sistem operasi Anda?",
  Windows_10_or_older: "Windows 10 atau lebih lama",
  speed: "Seberapa cepat koneksi internet Anda?",
  Less_than_1_Mbps: "Kurang dari 1 Mbps",
  More_than_100_Mbps: "Lebih dari 100 Mbps",
  freq: "Seberapa sering Anda menggunakan ekstensi?",
  Daily: "Harian",
  Weekly: "Mingguan",
  Monthly: "Bulanan",
  Rarely: "Jarang",
  purpose: "Untuk apa Anda menggunakan ekstensi ini?",
  translation: "Apakah Anda menemukan masalah terjemahan?",
  bugs: "Apakah Anda menemukan bug?",
  improve: "Apa yang bisa kami tingkatkan?",
  side: "Apakah Anda tahu tentang side panel?",
  convert: "Apakah Anda tahu konversi otomatis gambar?",
  rate: "Bagaimana Anda menilai kami?",
  anything: "Hal lain?",

  submit: "Kirim",

  thanks: "Terima Kasih",
  done: "Terima kasih atas masukan Anda. Anda menginstal ekstensi pada",
  pressed: "dan menekan tombol unduh",
  times: "kali.",

  share: "Bagikan Ekstensi",
  Share_extension: "Bagikan ekstensi",
  Rate_us: "Nilai kami",

  Other: "Lainnya",
  no: "Tidak ingin menjawab",
  yes: "Ya",
  no2: "Tidak",
  na: "N/A"
},

it: {
  step1: "Passo 1 di 2",
  step2: "Passo 2 di 2",
  title1: "Aiutaci a migliorare l'estensione",
  desc1:
    "La nostra estensione non raccoglie automaticamente dati degli utenti. Aiutaci a capire meglio l'uso condividendo dati tecnici in forma anonima.",
  collect: "Cosa raccogliamo:",
  collect1: "UID (codice casuale generato all'installazione)",
  collect2: "Versione estensione",
  collect3: "Data di installazione",
  collect4: "Numero di clic sul download",
  collect5: "Impostazioni escluse: filtro URL, prefisso cartella e file",
  allow: "Consenti raccolta anonima una tantum",

  title2: "Alcune domande (opzionali)",

  browser: "Qual è il tuo browser?",
  os: "Qual è il tuo sistema operativo?",
  Windows_10_or_older: "Windows 10 o precedente",
  speed: "Qual è la tua velocità internet?",
  Less_than_1_Mbps: "Meno di 1 Mbps",
  More_than_100_Mbps: "Più di 100 Mbps",
  freq: "Quanto usi l'estensione?",
  Daily: "Giornalmente",
  Weekly: "Settimanale",
  Monthly: "Mensile",
  Rarely: "Raramente",
  purpose: "Per cosa usi l'estensione?",
  translation: "Problemi di traduzione?",
  bugs: "Hai trovato bug?",
  improve: "Cosa possiamo migliorare?",
  side: "Conosci la side panel?",
  convert: "Conosci la conversione automatica?",
  rate: "Valutaci",
  anything: "Altro?",

  submit: "Invia",

  thanks: "Grazie",
  done: "Grazie per il feedback. Hai installato l'estensione il",
  pressed: "e hai premuto il download",
  times: "volte.",

  share: "Condividi estensione",
  Share_extension: "Condividi estensione",
  Rate_us: "Valutaci",

  Other: "Altro",
  no: "Non voglio rispondere",
  yes: "Sì",
  no2: "No",
  na: "N/D"
},

ja: {
  step1: "ステップ1/2",
  step2: "ステップ2/2",
  title1: "拡張機能の改善にご協力ください",
  desc1:
    "この拡張機能は自動でユーザーデータを収集しません。匿名の技術データ提供にご協力ください。",
  collect: "収集する内容:",
  collect1: "UID（インストール時のランダムID）",
  collect2: "拡張機能バージョン",
  collect3: "インストール日",
  collect4: "ダウンロード回数",
  collect5: "URLフィルタ・フォルダ/ファイル設定を除く設定情報",
  allow: "匿名データ収集を許可",

  title2: "いくつか質問です（任意）",

  browser: "ブラウザは？",
  os: "OSは？",
  Windows_10_or_older: "Windows 10以前",
  speed: "回線速度は？",
  Less_than_1_Mbps: "1 Mbps未満",
  More_than_100_Mbps: "100 Mbps以上",
  freq: "使用頻度は？",
  Daily: "毎日",
  Weekly: "週1回",
  Monthly: "月1回",
  Rarely: "ほとんど使わない",
  purpose: "用途は？",
  translation: "翻訳の問題はありましたか？",
  bugs: "バグはありましたか？",
  improve: "改善点は？",
  side: "サイドパネルを知っていましたか？",
  convert: "画像変換を知っていましたか？",
  rate: "評価してください",
  anything: "その他",

  submit: "送信",

  thanks: "ありがとうございます",
  done: "フィードバックありがとうございます。インストール日:",
  pressed: "ダウンロード回数:",
  times: "回",

  share: "共有",
  Share_extension: "拡張機能を共有",
  Rate_us: "評価する",

  Other: "その他",
  no: "回答しない",
  yes: "はい",
  no2: "いいえ",
  na: "N/A"
},

kn: {
  step1: "ಹಂತ 1 / 2",
  step2: "ಹಂತ 2 / 2",
  title1: "ನಮ್ಮ ಎಕ್ಸ್ಟೆನ್ಶನ್ ಸುಧಾರಿಸಲು ಸಹಾಯ ಮಾಡಿ",
  desc1:
    "ನಮ್ಮ ಎಕ್ಸ್ಟೆನ್ಶನ್ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಡೇಟಾ ಸಂಗ್ರಹಿಸುವುದಿಲ್ಲ. ಅನಾಮಧೇಯ ತಾಂತ್ರಿಕ ಡೇಟಾ ಹಂಚಿಕೊಳ್ಳಿ.",
  collect: "ನಾವು ಸಂಗ್ರಹಿಸುವುದು:",
  collect1: "UID",
  collect2: "ವರ್ಷನ್",
  collect3: "ಇನ್‌ಸ್ಟಾಲ್ ದಿನಾಂಕ",
  collect4: "ಡೌನ್‌ಲೋಡ್ ಕ್ಲಿಕ್ ಸಂಖ್ಯೆ",
  collect5: "ಸೆಟ್ಟಿಂಗ್ ಡೇಟಾ (ಫಿಲ್ಟರ್ ಹೊರತುಪಡಿಸಿ)",
  allow: "ಒಮ್ಮೆ ಅನಾಮಧೇಯ ಡೇಟಾ ಸಂಗ್ರಹಿಸಲು ಅನುಮತಿ",

  title2: "ಕೆಲವು ಪ್ರಶ್ನೆಗಳು (ಐಚ್ಛಿಕ)",

  browser: "ಬ್ರೌಸರ್?",
  os: "ಆಪರೇಟಿಂಗ್ ಸಿಸ್ಟಮ್?",
  Windows_10_or_older: "Windows 10 ಅಥವಾ ಹಳೆಯದು",
  speed: "ಇಂಟರ್ನೆಟ್ ವೇಗ?",
  Less_than_1_Mbps: "1 Mbps ಕ್ಕಿಂತ ಕಡಿಮೆ",
  More_than_100_Mbps: "100 Mbps ಕ್ಕಿಂತ ಹೆಚ್ಚು",
  freq: "ಬಳಕೆ ಆವೃತ್ತಿ?",
  Daily: "ದೈನಂದಿನ",
  Weekly: "ವಾರದ",
  Monthly: "ಮಾಸಿಕ",
  Rarely: "ಅಪರೂಪ",
  purpose: "ಬಳಕೆ ಏಕೆ?",
  translation: "ಅನುವಾದ ಸಮಸ್ಯೆಗಳಿವೆಯೆ?",
  bugs: "ಬಗ್‌ಗಳಿವೆಯೆ?",
  improve: "ಏನು ಸುಧಾರಿಸಬೇಕು?",
  side: "ಸೈಡ್ ಪ್ಯಾನೆಲ್ ಗೊತ್ತೇ?",
  convert: "ಚಿತ್ರ ಪರಿವರ್ತನೆ ಗೊತ್ತೇ?",
  rate: "ನಮ್ಮನ್ನು ಮೌಲ್ಯಮಾಪನ ಮಾಡಿ",
  anything: "ಇತರೆ",

  submit: "ಸಲ್ಲಿಸು",

  thanks: "ಧನ್ಯವಾದಗಳು",
  done: "ಧನ್ಯವಾದಗಳು. ಇನ್‌ಸ್ಟಾಲ್ ದಿನಾಂಕ:",
  pressed: "ಡೌನ್‌ಲೋಡ್ ಕ್ಲಿಕ್:",
  times: "ಬಾರಿ",

  share: "ಹಂಚಿ",
  Share_extension: "ಎಕ್ಸ್ಟೆನ್ಶನ್ ಹಂಚಿ",
  Rate_us: "ಮೌಲ್ಯಮಾಪನ ಮಾಡಿ",

  Other: "ಇತರೆ",
  no: "ಉತ್ತರಿಸಲು ಇಚ್ಛೆ ಇಲ್ಲ",
  yes: "ಹೌದು",
  no2: "ಇಲ್ಲ",
  na: "N/A"
},

ko: {
  step1: "1/2 단계",
  step2: "2/2 단계",
  title1: "확장 프로그램 개선 도움",
  desc1:
    "이 확장 프로그램은 자동으로 데이터를 수집하지 않습니다. 익명 기술 데이터를 공유해주세요.",
  collect: "수집 항목:",
  collect1: "UID",
  collect2: "버전",
  collect3: "설치 날짜",
  collect4: "다운로드 클릭 수",
  collect5: "설정 정보 일부 제외",
  allow: "익명 데이터 수집 허용",

  title2: "몇 가지 질문 (선택)",

  browser: "브라우저?",
  os: "운영체제?",
  Windows_10_or_older: "Windows 10 이하",
  speed: "인터넷 속도?",
  Less_than_1_Mbps: "1 Mbps 미만",
  More_than_100_Mbps: "100 Mbps 이상",
  freq: "사용 빈도?",
  Daily: "매일",
  Weekly: "주간",
  Monthly: "월간",
  Rarely: "거의 안씀",
  purpose: "사용 목적?",
  translation: "번역 문제?",
  bugs: "버그 발생?",
  improve: "개선점?",
  side: "사이드 패널을 알고 있었나요?",
  convert: "이미지 변환 기능 알고 있었나요?",
  rate: "평가",
  anything: "기타",

  submit: "제출",

  thanks: "감사합니다",
  done: "설치일:",
  pressed: "다운로드 클릭:",
  times: "회",

  share: "공유",
  Share_extension: "확장 공유",
  Rate_us: "평가",

  Other: "기타",
  no: "답변 안함",
  yes: "예",
  no2: "아니오",
  na: "해당 없음"
},

lt: {
  step1: "1/2 žingsnis",
  step2: "2/2 žingsnis",
  title1: "Padėkite patobulinti plėtinį",
  desc1:
    "Plėtinys automatiškai nerenka duomenų. Padėkite anonimiškai pasidalindami techniniais duomenimis.",
  collect: "Ką renkame:",
  collect1: "UID",
  collect2: "Versija",
  collect3: "Įdiegimo data",
  collect4: "Atsisiuntimų skaičius",
  collect5: "Nustatymai (išskyrus filtrus)",
  allow: "Leisti anoniminį duomenų rinkimą",

  title2: "Keli klausimai (nebūtina)",

  browser: "Naršyklė?",
  os: "OS?",
  Windows_10_or_older: "Windows 10 ar senesnė",
  speed: "Interneto greitis?",
  Less_than_1_Mbps: "Mažiau nei 1 Mbps",
  More_than_100_Mbps: "Daugiau nei 100 Mbps",
  freq: "Naudojimo dažnis?",
  Daily: "Kasdien",
  Weekly: "Kas savaitę",
  Monthly: "Kas mėnesį",
  Rarely: "Retai",
  purpose: "Naudojimas?",
  translation: "Vertimo problemos?",
  bugs: "Klaidų?",
  improve: "Ką pagerinti?",
  side: "Ar žinojote apie šoninį langą?",
  convert: "Ar žinojote apie konvertavimą?",
  rate: "Įvertinkite",
  anything: "Kita",

  submit: "Pateikti",

  thanks: "Ačiū",
  done: "Ačiū. Įdiegimo data:",
  pressed: "Atsisiuntimų:",
  times: "kartų",

  share: "Dalintis",
  Share_extension: "Dalintis plėtiniu",
  Rate_us: "Įvertinti",

  Other: "Kita",
  no: "Nenoriu atsakyti",
  yes: "Taip",
  no2: "Ne",
  na: "N/A"
},

lv: {
  step1: "1/2 solis",
  step2: "2/2 solis",
  title1: "Palīdzi uzlabot paplašinājumu",
  desc1:
    "Paplašinājums automātiski nevāc datus. Palīdzi, daloties anonīmos datos.",
  collect: "Ko mēs vācam:",
  collect1: "UID",
  collect2: "Versija",
  collect3: "Instalācijas datums",
  collect4: "Lejupielāžu skaits",
  collect5: "Iestatījumi (bez filtriem)",
  allow: "Atļaut anonīmu datu vākšanu",

  title2: "Daži jautājumi (nav obligāti)",

  browser: "Pārlūks?",
  os: "OS?",
  Windows_10_or_older: "Windows 10 vai vecāka",
  speed: "Interneta ātrums?",
  Less_than_1_Mbps: "Mazāk nekā 1 Mbps",
  More_than_100_Mbps: "Vairāk nekā 100 Mbps",
  freq: "Lietošanas biežums?",
  Daily: "Katru dienu",
  Weekly: "Katru nedēļu",
  Monthly: "Katru mēnesi",
  Rarely: "Reti",
  purpose: "Lietojums?",
  translation: "Tulkošanas problēmas?",
  bugs: "Kļūdas?",
  improve: "Uzlabojumi?",
  side: "Vai zinājāt par sānu paneli?",
  convert: "Vai zinājāt par konvertēšanu?",
  rate: "Novērtējiet",
  anything: "Cits",

  submit: "Iesniegt",

  thanks: "Paldies",
  done: "Paldies. Instalācijas datums:",
  pressed: "Lejupielādes:",
  times: "reizes",

  share: "Dalīties",
  Share_extension: "Dalīties paplašinājumu",
  Rate_us: "Novērtēt",

  Other: "Cits",
  no: "Nevēlos atbildēt",
  yes: "Jā",
  no2: "Nē",
  na: "N/A"
},

ml: {
  step1: "ഘട്ടം 1 / 2",
  step2: "ഘട്ടം 2 / 2",
  title1: "എക്സ്റ്റൻഷൻ മെച്ചപ്പെടുത്താൻ സഹായിക്കുക",
  desc1:
    "എക്സ്റ്റൻഷൻ സ്വയം ഡാറ്റ ശേഖരിക്കുന്നില്ല. അനോണിമസ് ഡാറ്റ പങ്കിടുക.",
  collect: "ഞങ്ങൾ ശേഖരിക്കുന്നത്:",
  collect1: "UID",
  collect2: "വർഷൻ",
  collect3: "ഇൻസ്റ്റാൾ തീയതി",
  collect4: "ഡൗൺലോഡ് എണ്ണം",
  collect5: "ചില സെറ്റിംഗുകൾ ഒഴിവാക്കി",
  allow: "ഒറ്റത്തവണ അനോണിമസ് ഡാറ്റ അനുവദിക്കുക",

  title2: "ചില ചോദ്യങ്ങൾ (ഓപ്ഷണൽ)",

  browser: "ബ്രൗസർ?",
  os: "ഓപ്പറേറ്റിംഗ് സിസ്റ്റം?",
  Windows_10_or_older: "Windows 10 അല്ലെങ്കിൽ പഴയത്",
  speed: "ഇന്റർനെറ്റ് വേഗം?",
  Less_than_1_Mbps: "1 Mbps-ൽ താഴെ",
  More_than_100_Mbps: "100 Mbps-ൽ കൂടുതൽ",
  freq: "ഉപയോഗം?",
  Daily: "ദിനംപ്രതി",
  Weekly: "ആഴ്ചയിൽ",
  Monthly: "മാസത്തിൽ",
  Rarely: "അപൂർവ്വം",
  purpose: "ഉപയോഗം എന്തിന്?",
  translation: "ഭാഷാ പ്രശ്നങ്ങൾ?",
  bugs: "ബഗുകൾ ഉണ്ടോ?",
  improve: "മെച്ചപ്പെടുത്തൽ?",
  side: "സൈഡ് പാനൽ അറിയാമോ?",
  convert: "ഇമേജ് കൺവേർഷൻ അറിയാമോ?",
  rate: "റേറ്റ് ചെയ്യുക",
  anything: "മറ്റൊന്ന്",

  submit: "സമർപ്പിക്കുക",

  thanks: "നന്ദി",
  done: "നന്ദി. ഇൻസ്റ്റാൾ തീയതി:",
  pressed: "ഡൗൺലോഡ് എണ്ണം:",
  times: "പ്രാവശ്യം",

  share: "പങ്കിടുക",
  Share_extension: "എക്സ്റ്റൻഷൻ പങ്കിടുക",
  Rate_us: "റേറ്റ് ചെയ്യുക",

  Other: "മറ്റൊന്ന്",
  no: "ഉത്തരം വേണ്ട",
  yes: "അതെ",
  no2: "ഇല്ല",
  na: "N/A"
},

mr: {
  step1: "पायरी 1 / 2",
  step2: "पायरी 2 / 2",
  title1: "आमच्या एक्स्टेन्शनमध्ये सुधारणा करा",
  desc1:
    "एक्स्टेन्शन स्वयंचलित डेटा गोळा करत नाही. अनामिक डेटा शेअर करा.",
  collect: "आम्ही काय गोळा करतो:",
  collect1: "UID",
  collect2: "व्हर्जन",
  collect3: "इंस्टॉल तारीख",
  collect4: "डाउनलोड संख्या",
  collect5: "काही सेटिंग्ज वगळून",
  allow: "एकदा अनामिक डेटा संमती द्या",

  title2: "काही प्रश्न (ऐच्छिक)",

  browser: "ब्राउझर?",
  os: "ऑपरेटिंग सिस्टीम?",
  Windows_10_or_older: "Windows 10 किंवा जुने",
  speed: "इंटरनेट स्पीड?",
  Less_than_1_Mbps: "1 Mbps पेक्षा कमी",
  More_than_100_Mbps: "100 Mbps पेक्षा जास्त",
  freq: "वापर वारंवारता?",
  Daily: "दररोज",
  Weekly: "आठवड्याला",
  Monthly: "महिन्याला",
  Rarely: "क्वचित",
  purpose: "कशासाठी वापरता?",
  translation: "भाषांतर समस्या?",
  bugs: "बग्स?",
  improve: "सुधारणा?",
  side: "साइड पॅनेल माहिती आहे का?",
  convert: "इमेज कन्व्हर्जन माहिती आहे का?",
  rate: "रेट करा",
  anything: "इतर",

  submit: "सबमिट",

  thanks: "धन्यवाद",
  done: "धन्यवाद. इंस्टॉल तारीख:",
  pressed: "डाउनलोड:",
  times: "वेळा",

  share: "शेअर",
  Share_extension: "एक्स्टेन्शन शेअर करा",
  Rate_us: "रेट करा",

  Other: "इतर",
  no: "उत्तर द्यायचे नाही",
  yes: "होय",
  no2: "नाही",
  na: "N/A"
},

ms: {
  step1: "Langkah 1 / 2",
  step2: "Langkah 2 / 2",
  title1: "Bantu tingkatkan sambungan ini",
  desc1:
    "Sambungan tidak mengumpul data secara automatik. Sila kongsi data teknikal tanpa nama.",
  collect: "Apa yang kami kumpul:",
  collect1: "UID",
  collect2: "Versi",
  collect3: "Tarikh pemasangan",
  collect4: "Kiraan muat turun",
  collect5: "Tetapan tertentu dikecualikan",
  allow: "Benarkan pengumpulan data tanpa nama sekali",

  title2: "Beberapa soalan (pilihan)",

  browser: "Pelayar?",
  os: "Sistem operasi?",
  Windows_10_or_older: "Windows 10 atau lebih lama",
  speed: "Kelajuan internet?",
  Less_than_1_Mbps: "Kurang 1 Mbps",
  More_than_100_Mbps: "Lebih 100 Mbps",
  freq: "Kekerapan penggunaan?",
  Daily: "Harian",
  Weekly: "Mingguan",
  Monthly: "Bulanan",
  Rarely: "Jarang",
  purpose: "Tujuan penggunaan?",
  translation: "Masalah terjemahan?",
  bugs: "Ada bug?",
  improve: "Cadangan?",
  side: "Tahu panel sisi?",
  convert: "Tahu penukaran imej?",
  rate: "Nilai kami",
  anything: "Lain-lain",

  submit: "Hantar",

  thanks: "Terima kasih",
  done: "Terima kasih. Tarikh pemasangan:",
  pressed: "Klik muat turun:",
  times: "kali",

  share: "Kongsi",
  Share_extension: "Kongsi sambungan",
  Rate_us: "Nilai",

  Other: "Lain-lain",
  no: "Tidak mahu jawab",
  yes: "Ya",
  no2: "Tidak",
  na: "N/A"
},

nl: {
  step1: "Stap 1 / 2",
  step2: "Stap 2 / 2",
  title1: "Help onze extensie verbeteren",
  desc1:
    "De extensie verzamelt geen data automatisch. Deel anonieme technische gegevens.",
  collect: "Wat we verzamelen:",
  collect1: "UID",
  collect2: "Versie",
  collect3: "Installatiedatum",
  collect4: "Aantal downloads",
  collect5: "Instellingen (behalve filters)",
  allow: "Sta eenmalige anonieme data toe",

  title2: "Enkele vragen (optioneel)",

  browser: "Browser?",
  os: "Besturingssysteem?",
  Windows_10_or_older: "Windows 10 of ouder",
  speed: "Internetsnelheid?",
  Less_than_1_Mbps: "Minder dan 1 Mbps",
  More_than_100_Mbps: "Meer dan 100 Mbps",
  freq: "Gebruik?",
  Daily: "Dagelijks",
  Weekly: "Wekelijks",
  Monthly: "Maandelijks",
  Rarely: "Zelden",
  purpose: "Gebruik?",
  translation: "Vertaalproblemen?",
  bugs: "Bugs?",
  improve: "Verbeteringen?",
  side: "Weet je van zijpaneel?",
  convert: "Weet je van conversie?",
  rate: "Beoordeel ons",
  anything: "Overig",

  submit: "Verzenden",

  thanks: "Bedankt",
  done: "Bedankt. Installatiedatum:",
  pressed: "Downloads:",
  times: "keer",

  share: "Delen",
  Share_extension: "Extensie delen",
  Rate_us: "Beoordeel",

  Other: "Overig",
  no: "Geen antwoord",
  yes: "Ja",
  no2: "Nee",
  na: "N/A"
},

no: {
  step1: "Trinn 1 / 2",
  step2: "Trinn 2 / 2",
  title1: "Hjelp oss å forbedre utvidelsen",
  desc1:
    "Utvidelsen samler ikke data automatisk. Del anonym teknisk data.",
  collect: "Hva vi samler:",
  collect1: "UID",
  collect2: "Versjon",
  collect3: "Installasjonsdato",
  collect4: "Antall nedlastinger",
  collect5: "Innstillinger unntatt filtre",
  allow: "Tillat anonym datainnsamling",

  title2: "Noen spørsmål (valgfritt)",

  browser: "Nettleser?",
  os: "OS?",
  Windows_10_or_older: "Windows 10 eller eldre",
  speed: "Internett hastighet?",
  Less_than_1_Mbps: "Mindre enn 1 Mbps",
  More_than_100_Mbps: "Mer enn 100 Mbps",
  freq: "Bruk?",
  Daily: "Daglig",
  Weekly: "Ukentlig",
  Monthly: "Månedlig",
  Rarely: "Sjelden",
  purpose: "Bruk?",
  translation: "Oversettelsesproblemer?",
  bugs: "Feil?",
  improve: "Forbedringer?",
  side: "Kjenner du sidepanel?",
  convert: "Kjenner du konvertering?",
  rate: "Vurder oss",
  anything: "Annet",

  submit: "Send inn",

  thanks: "Takk",
  done: "Takk. Installert:",
  pressed: "Nedlastinger:",
  times: "ganger",

  share: "Del",
  Share_extension: "Del utvidelse",
  Rate_us: "Vurder",

  Other: "Annet",
  no: "Vil ikke svare",
  yes: "Ja",
  no2: "Nei",
  na: "N/A"
},

pl: {
  step1: "Krok 1 / 2",
  step2: "Krok 2 / 2",
  title1: "Pomóż ulepszyć rozszerzenie",
  desc1:
    "Rozszerzenie nie zbiera automatycznie danych. Udostępnij anonimowe dane techniczne.",
  collect: "Co zbieramy:",
  collect1: "UID",
  collect2: "Wersja",
  collect3: "Data instalacji",
  collect4: "Liczba pobrań",
  collect5: "Ustawienia bez filtrów",
  allow: "Zezwól na jednorazowe dane anonimowe",

  title2: "Kilka pytań (opcjonalne)",

  browser: "Przeglądarka?",
  os: "System?",
  Windows_10_or_older: "Windows 10 lub starszy",
  speed: "Szybkość internetu?",
  Less_than_1_Mbps: "Mniej niż 1 Mbps",
  More_than_100_Mbps: "Ponad 100 Mbps",
  freq: "Częstotliwość użycia?",
  Daily: "Codziennie",
  Weekly: "Tygodniowo",
  Monthly: "Miesięcznie",
  Rarely: "Rzadko",
  purpose: "Do czego używasz?",
  translation: "Problemy z tłumaczeniem?",
  bugs: "Błędy?",
  improve: "Co poprawić?",
  side: "Znajomość panelu bocznego?",
  convert: "Znajomość konwersji?",
  rate: "Oceń nas",
  anything: "Inne",

  submit: "Wyślij",

  thanks: "Dziękujemy",
  done: "Dziękujemy. Data instalacji:",
  pressed: "Kliknięcia pobrania:",
  times: "razy",

  share: "Udostępnij",
  Share_extension: "Udostępnij rozszerzenie",
  Rate_us: "Oceń",

  Other: "Inne",
  no: "Nie chcę odpowiadać",
  yes: "Tak",
  no2: "Nie",
  na: "N/A"
},

pt: {
  step1: "Passo 1 / 2",
  step2: "Passo 2 / 2",
  title1: "Ajude a melhorar a extensão",
  desc1:
    "A extensão não coleta dados automaticamente. Compartilhe dados técnicos anonimamente.",
  collect: "O que coletamos:",
  collect1: "UID",
  collect2: "Versão",
  collect3: "Data de instalação",
  collect4: "Número de downloads",
  collect5: "Configurações exceto filtros",
  allow: "Permitir coleta anônima única",

  title2: "Algumas perguntas (opcional)",

  browser: "Navegador?",
  os: "Sistema operacional?",
  Windows_10_or_older: "Windows 10 ou mais antigo",
  speed: "Velocidade da internet?",
  Less_than_1_Mbps: "Menos de 1 Mbps",
  More_than_100_Mbps: "Mais de 100 Mbps",
  freq: "Frequência de uso?",
  Daily: "Diário",
  Weekly: "Semanal",
  Monthly: "Mensal",
  Rarely: "Raramente",
  purpose: "Uso?",
  translation: "Problemas de tradução?",
  bugs: "Bugs?",
  improve: "Melhorias?",
  side: "Conhece painel lateral?",
  convert: "Conhece conversão?",
  rate: "Avalie-nos",
  anything: "Outro",

  submit: "Enviar",

  thanks: "Obrigado",
  done: "Obrigado. Data de instalação:",
  pressed: "Downloads:",
  times: "vezes",

  share: "Compartilhar",
  Share_extension: "Compartilhar extensão",
  Rate_us: "Avaliar",

  Other: "Outro",
  no: "Não quero responder",
  yes: "Sim",
  no2: "Não",
  na: "N/A"
},
ro: {
  step1: "Pasul 1 din 2",
  step2: "Pasul 2 din 2",
  title1: "Ajută-ne să îmbunătățim extensia",
  desc1:
    "Extensia noastră nu colectează automat datele utilizatorilor. Ajută-ne să înțelegem mai bine cum este folosită, oferind câteva date tehnice anonime.",
  collect: "Ce am colecta:",
  collect1: "UID (un cod aleator creat la instalare)",
  collect2: "Versiunea extensiei",
  collect3: "Data instalării",
  collect4: "Numărul de apăsări pe butonul de descărcare",
  collect5: "Setări excluzând: filtrul URL, prefix folder și prefix fișier",
  allow: "Permite colectarea anonimă unică a datelor tehnice",

  title2: "Avem câteva întrebări pentru tine (toate sunt opționale)",

  browser: "Ce browser folosești?",
  os: "Ce sistem de operare folosești?",
  Windows_10_or_older: "Windows 10 sau mai vechi",
  speed: "Care este viteza conexiunii tale?",
  Less_than_1_Mbps: "Mai puțin de 1 Mbps",
  More_than_100_Mbps: "Peste 100 Mbps",
  freq: "Cât de des folosești extensia?",
  Daily: "Zilnic",
  Weekly: "Săptămânal",
  Monthly: "Lunar",
  Rarely: "Rar",
  purpose: "Pentru ce folosești extensia?",
  translation: "Ai întâmpinat probleme de traducere?",
  bugs: "Ai întâmpinat erori?",
  improve: "Ce putem îmbunătăți?",
  side: "Știai că poți deschide extensia ca panou lateral?",
  convert: "Știai că poți converti automat imaginile?",
  rate: "Cum ne-ai evalua?",
  anything: "Altceva?",

  submit: "Trimite feedback",
  thanks: "Mulțumim",
  done: "Mulțumim pentru feedback. Ai instalat extensia pe",
  pressed: "și ai apăsat butonul de descărcare",
  times: "ori.",

  share: "Distribuie extensia",
  Share_extension: "Distribuie extensia",
  Rate_us: "Evaluează-ne",

  Other: "Altul",
  no: "Nu vreau să răspund",
  yes: "Da",
  no2: "Nu",
  na: "N/A"
},

ru: {
  step1: "Шаг 1 из 2",
  step2: "Шаг 2 из 2",
  title1: "Помогите улучшить расширение",
  desc1:
    "Наше расширение не собирает данные автоматически. Помогите нам понять, как оно используется, предоставив анонимные технические данные.",
  collect: "Что мы собираем:",
  collect1: "UID (случайный код при установке)",
  collect2: "Версия расширения",
  collect3: "Дата установки",
  collect4: "Количество нажатий на кнопку загрузки",
  collect5: "Настройки без: фильтра URL, префикса папки и файла",
  allow: "Разрешить одноразовый сбор анонимных данных",

  title2: "Несколько вопросов (все необязательные)",

  browser: "Какой у вас браузер?",
  os: "Какая у вас ОС?",
  Windows_10_or_older: "Windows 10 или старше",
  speed: "Скорость интернета?",
  Less_than_1_Mbps: "Менее 1 Мбит/с",
  More_than_100_Mbps: "Более 100 Мбит/с",
  freq: "Как часто используете?",
  Daily: "Ежедневно",
  Weekly: "Еженедельно",
  Monthly: "Ежемесячно",
  Rarely: "Редко",
  purpose: "Для чего используете?",
  translation: "Проблемы с переводом?",
  bugs: "Были ошибки?",
  improve: "Что улучшить?",
  side: "Знали про боковую панель?",
  convert: "Знали про конвертацию изображений?",
  rate: "Оцените нас",
  anything: "Что-то ещё?",

  submit: "Отправить",
  thanks: "Спасибо",
  done: "Спасибо за отзыв. Вы установили расширение",
  pressed: "и нажали кнопку загрузки",
  times: "раз.",

  share: "Поделиться",
  Share_extension: "Поделиться расширением",
  Rate_us: "Оценить",

  Other: "Другое",
  no: "Не хочу отвечать",
  yes: "Да",
  no2: "Нет",
  na: "Н/Д"
},

sk: {
  step1: "Krok 1 z 2",
  step2: "Krok 2 z 2",
  title1: "Pomôžte nám zlepšiť rozšírenie",
  desc1:
    "Naše rozšírenie automaticky nezhromažďuje údaje používateľov. Pomôžte nám pochopiť jeho používanie poskytnutím anonymných technických údajov.",
  collect: "Čo zbierame:",
  collect1: "UID (náhodný kód pri inštalácii)",
  collect2: "Verzia rozšírenia",
  collect3: "Dátum inštalácie",
  collect4: "Počet kliknutí na tlačidlo sťahovania",
  collect5: "Nastavenia okrem: URL filtra, prefixu priečinka a súboru",
  allow: "Povoliť jednorazový anonymný zber údajov",

  title2: "Niekoľko otázok (všetky sú voliteľné)",

  browser: "Aký používate prehliadač?",
  os: "Aký používate operačný systém?",
  Windows_10_or_older: "Windows 10 alebo starší",
  speed: "Rýchlosť internetu?",
  Less_than_1_Mbps: "Menej ako 1 Mbps",
  More_than_100_Mbps: "Viac ako 100 Mbps",
  freq: "Ako často používate rozšírenie?",
  Daily: "Denne",
  Weekly: "Týždenne",
  Monthly: "Mesačne",
  Rarely: "Zriedka",
  purpose: "Na čo používate rozšírenie?",
  translation: "Stretli ste sa s problémami prekladu?",
  bugs: "Stretli ste sa s chybami?",
  improve: "Čo môžeme zlepšiť?",
  side: "Vedeli ste o bočnom paneli?",
  convert: "Vedeli ste o konverzii obrázkov?",
  rate: "Ako nás hodnotíte?",
  anything: "Niečo iné?",

  submit: "Odoslať",
  thanks: "Ďakujeme",
  done: "Ďakujeme za spätnú väzbu. Nainštalovali ste rozšírenie",
  pressed: "a stlačili ste tlačidlo sťahovania",
  times: "krát.",

  share: "Zdieľať",
  Share_extension: "Zdieľať rozšírenie",
  Rate_us: "Ohodnoťte nás",

  Other: "Iné",
  no: "Nechcem odpovedať",
  yes: "Áno",
  no2: "Nie",
  na: "N/A"
},

sl: {
  step1: "Korak 1 od 2",
  step2: "Korak 2 od 2",
  title1: "Pomagajte izboljšati razširitev",
  desc1:
    "Naša razširitev ne zbira podatkov samodejno. Pomagajte nam razumeti uporabo z anonimnimi tehničnimi podatki.",
  collect: "Kaj zbiramo:",
  collect1: "UID (naključna koda ob namestitvi)",
  collect2: "Različica razširitve",
  collect3: "Datum namestitve",
  collect4: "Število klikov gumba za prenos",
  collect5: "Nastavitve brez: URL filtra, predpone mape in datoteke",
  allow: "Dovoli enkratno anonimno zbiranje podatkov",

  title2: "Nekaj vprašanj (vsa so neobvezna)",

  browser: "Kateri brskalnik uporabljate?",
  os: "Kateri operacijski sistem uporabljate?",
  Windows_10_or_older: "Windows 10 ali starejši",
  speed: "Hitrost interneta?",
  Less_than_1_Mbps: "Manj kot 1 Mbps",
  More_than_100_Mbps: "Več kot 100 Mbps",
  freq: "Kako pogosto uporabljate razširitev?",
  Daily: "Dnevno",
  Weekly: "Tedensko",
  Monthly: "Mesečno",
  Rarely: "Redko",
  purpose: "Za kaj uporabljate razširitev?",
  translation: "Težave s prevodi?",
  bugs: "Napake?",
  improve: "Kaj izboljšati?",
  side: "Ste vedeli za stranski panel?",
  convert: "Ste vedeli za pretvorbo slik?",
  rate: "Kako nas ocenjujete?",
  anything: "Še kaj?",

  submit: "Pošlji",
  thanks: "Hvala",
  done: "Hvala za povratne informacije. Namestili ste razširitev",
  pressed: "in kliknili gumb za prenos",
  times: "krat.",

  share: "Deli",
  Share_extension: "Deli razširitev",
  Rate_us: "Ocenite nas",

  Other: "Drugo",
  no: "Ne želim odgovoriti",
  yes: "Da",
  no2: "Ne",
  na: "N/A"
},

sr: {
  step1: "Korak 1 od 2",
  step2: "Korak 2 od 2",
  title1: "Pomozite da poboljšamo ekstenziju",
  desc1:
    "Naša ekstenzija ne prikuplja podatke automatski. Pomozite nam da razumemo upotrebu anonimnim tehničkim podacima.",
  collect: "Šta prikupljamo:",
  collect1: "UID (nasumični kod pri instalaciji)",
  collect2: "Verzija ekstenzije",
  collect3: "Datum instalacije",
  collect4: "Broj klikova na dugme za preuzimanje",
  collect5: "Podešavanja bez: URL filtera, prefiksa foldera i fajla",
  allow: "Dozvoli jednokratno anonimno prikupljanje podataka",

  title2: "Nekoliko pitanja (sva su opcionalna)",

  browser: "Koji browser koristite?",
  os: "Koji operativni sistem koristite?",
  Windows_10_or_older: "Windows 10 ili stariji",
  speed: "Brzina interneta?",
  Less_than_1_Mbps: "Manje od 1 Mbps",
  More_than_100_Mbps: "Više od 100 Mbps",
  freq: "Koliko često koristite ekstenziju?",
  Daily: "Dnevno",
  Weekly: "Nedeljno",
  Monthly: "Mesečno",
  Rarely: "Retko",
  purpose: "Za šta koristite ekstenziju?",
  translation: "Problemi sa prevodom?",
  bugs: "Greške?",
  improve: "Šta poboljšati?",
  side: "Da li ste znali za bočni panel?",
  convert: "Da li ste znali za konverziju slika?",
  rate: "Kako nas ocenjujete?",
  anything: "Nešto drugo?",

  submit: "Pošalji",
  thanks: "Hvala",
  done: "Hvala na povratnim informacijama. Instalirali ste ekstenziju",
  pressed: "i kliknuli dugme za preuzimanje",
  times: "puta.",

  share: "Podeli",
  Share_extension: "Podeli ekstenziju",
  Rate_us: "Oceni nas",

  Other: "Ostalo",
  no: "Ne želim da odgovorim",
  yes: "Da",
  no2: "Ne",
  na: "N/A"
},

sv: {
  step1: "Steg 1 av 2",
  step2: "Steg 2 av 2",
  title1: "Hjälp oss förbättra tillägget",
  desc1:
    "Vårt tillägg samlar inte automatiskt in data. Hjälp oss förstå användningen genom anonym teknisk data.",
  collect: "Vad vi samlar in:",
  collect1: "UID (slumpkod vid installation)",
  collect2: "Tilläggets version",
  collect3: "Installationsdatum",
  collect4: "Antal klick på nedladdningsknappen",
  collect5: "Inställningar exklusive URL-filter, mapp- och filprefix",
  allow: "Tillåt engångsanonym insamling av teknisk data",

  title2: "Några frågor (alla är valfria)",

  browser: "Vilken webbläsare använder du?",
  os: "Vilket operativsystem använder du?",
  Windows_10_or_older: "Windows 10 eller äldre",
  speed: "Internet hastighet?",
  Less_than_1_Mbps: "Mindre än 1 Mbps",
  More_than_100_Mbps: "Mer än 100 Mbps",
  freq: "Hur ofta använder du tillägget?",
  Daily: "Dagligen",
  Weekly: "Veckovis",
  Monthly: "Månadsvis",
  Rarely: "Sällan",
  purpose: "Vad använder du tillägget till?",
  translation: "Problem med översättning?",
  bugs: "Buggar?",
  improve: "Vad kan förbättras?",
  side: "Visste du om sidopanelen?",
  convert: "Visste du om bildkonvertering?",
  rate: "Hur skulle du betygsätta oss?",
  anything: "Något annat?",

  submit: "Skicka",
  thanks: "Tack",
  done: "Tack för din feedback. Du installerade tillägget",
  pressed: "och klickade på nedladdningsknappen",
  times: "gånger.",

  share: "Dela",
  Share_extension: "Dela tillägget",
  Rate_us: "Betygsätt oss",

  Other: "Annat",
  no: "Vill inte svara",
  yes: "Ja",
  no2: "Nej",
  na: "N/A"
},
sw: {
  step1: "Hatua ya 1 kati ya 2",
  step2: "Hatua ya 2 kati ya 2",
  title1: "Saidia Kuboresha Kiendelezi Chetu",
  desc1:
    "Kiendelezi chetu hakikusanyi data ya watumiaji kiotomatiki. Tusaidie kuelewa jinsi kinavyotumika kwa kushiriki data ya kiufundi kwa njia isiyojulikana.",
  collect: "Tutakachokusanya:",
  collect1: "UID (msimbo wa nasibu ulioundwa wakati wa usakinishaji)",
  collect2: "Toleo la kiendelezi",
  collect3: "Tarehe ya usakinishaji",
  collect4: "Idadi ya mara kitufe cha kupakua kilibonyezwa",
  collect5: "Mipangilio bila maudhui ya: kichujio cha URL, kiambishi cha folda, na kiambishi cha faili",
  allow: "Ruhusu ukusanyaji wa mara moja wa data ya kiufundi",

  title2: "Tuna maswali machache kwako (yote ni ya hiari)",

  browser: "Unatumia kivinjari gani?",
  os: "Unatumia mfumo gani wa uendeshaji?",
  Windows_10_or_older: "Windows 10 au ya zamani zaidi",
  speed: "Kasi yako ya intaneti ni nini?",
  Less_than_1_Mbps: "Chini ya 1 Mbps",
  More_than_100_Mbps: "Zaidi ya 100 Mbps",
  freq: "Unatumia kiendelezi mara ngapi?",
  Daily: "Kila siku",
  Weekly: "Kila wiki",
  Monthly: "Kila mwezi",
  Rarely: "Mara chache",
  purpose: "Unatumia kiendelezi kwa ajili gani?",
  translation: "Je, umekutana na matatizo ya tafsiri?",
  bugs: "Je, umekutana na hitilafu yoyote?",
  improve: "Tunaweza kuboresha nini?",
  side: "Je, ulijua unaweza kufungua kiendelezi kama paneli ya pembeni?",
  convert: "Je, ulijua unaweza kubadilisha aina za picha kiotomatiki?",
  rate: "Ungetupimiaje?",
  anything: "Kitu kingine chochote?",
  submit: "Tuma Maoni",

  thanks: "Asante",
  done: "Asante kwa maoni yako. Ulisakinisha kiendelezi mnamo",
  pressed: "na ulibonyeza kitufe cha kupakua",
  times: "mara.",

  share: "Shiriki Kiendelezi",
  Share_extension: "Shiriki kiendelezi",
  Rate_us: "Tupime",

  Other: "Nyingine",
  no: "Sitaki kujibu",
  yes: "Ndiyo",
  no2: "Hapana",
  na: "Haina matumizi"
},

ta: {
  step1: "படி 1 / 2",
  step2: "படி 2 / 2",
  title1: "எங்கள் நீட்டிப்பை மேம்படுத்த உதவுங்கள்",
  desc1:
    "எங்கள் நீட்டிப்பு பயனர் தரவை தானாக சேகரிக்காது. அநாமதேயமாக சில தொழில்நுட்ப தரவை பகிர்ந்து எங்களை உதவுங்கள்.",
  collect: "நாம் சேகரிப்பது:",
  collect1: "UID (நிறுவலின் போது உருவாக்கப்படும் குறியீடு)",
  collect2: "நீட்டிப்பு பதிப்பு",
  collect3: "நிறுவல் தேதி",
  collect4: "பதிவிறக்க பொத்தான் அழுத்தப்பட்ட எண்ணிக்கை",
  collect5: "URL வடிகட்டி, கோப்புறை முன்னொட்டு, கோப்பு முன்னொட்டு தவிர்ந்த அமைப்புகள்",
  allow: "ஒருமுறை அநாமதேய தர சேகரிப்பை அனுமதிக்கவும்",

  title2: "சில கேள்விகள் (விருப்பமானவை)",

  browser: "உங்கள் உலாவி என்ன?",
  os: "உங்கள் இயக்க முறைமை என்ன?",
  Windows_10_or_older: "Windows 10 அல்லது பழையது",
  speed: "உங்கள் இணைய வேகம்?",
  Less_than_1_Mbps: "1 Mbps க்குக் கீழ்",
  More_than_100_Mbps: "100 Mbps க்கும் மேல்",
  freq: "நீங்கள் எவ்வளவு அடிக்கடி பயன்படுத்துகிறீர்கள்?",
  Daily: "தினசரி",
  Weekly: "வாரந்தோறும்",
  Monthly: "மாதந்தோறும்",
  Rarely: "அரிதாக",
  purpose: "நீங்கள் இதைப் பயன்படுத்துவது என்னக்கு?",
  translation: "மொழிபெயர்ப்பு பிரச்சினைகள் இருந்ததா?",
  bugs: "பிழைகள் இருந்ததா?",
  improve: "எதை மேம்படுத்தலாம்?",
  side: "நீங்கள் பக்க பட்டியை அறிந்திருந்தீர்களா?",
  convert: "பட வடிவ மாற்றம் பற்றி அறிந்திருந்தீர்களா?",
  rate: "எங்களை மதிப்பிடுங்கள்",
  anything: "வேறு ஏதும்?",

  submit: "அனுப்பவும்",

  thanks: "நன்றி",
  done: "உங்கள் கருத்துக்கு நன்றி. நீங்கள் நிறுவியது",
  pressed: "மற்றும் பதிவிறக்க பொத்தானை அழுத்தியது",
  times: "முறை.",

  share: "பகிரவும்",
  Share_extension: "நீட்டிப்பை பகிரவும்",
  Rate_us: "மதிப்பிடவும்",

  Other: "மற்றவை",
  no: "பதில் வேண்டாம்",
  yes: "ஆம்",
  no2: "இல்லை",
  na: "பொருந்தாது"
},

te: {
  step1: "దశ 1 / 2",
  step2: "దశ 2 / 2",
  title1: "మా ఎక్స్‌టెన్షన్‌ను మెరుగుపరచడానికి సహాయం చేయండి",
  desc1:
    "మా ఎక్స్‌టెన్షన్ వినియోగదారు డేటాను స్వయంచాలకంగా సేకరించదు. అనామకంగా కొన్ని సాంకేతిక డేటాను పంచుకోండి.",
  collect: "మేము సేకరించేది:",
  collect1: "UID (ఇన్‌స్టాలేషన్ సమయంలో సృష్టించబడిన కోడ్)",
  collect2: "ఎక్స్‌టెన్షన్ వెర్షన్",
  collect3: "ఇన్‌స్టాలేషన్ తేదీ",
  collect4: "డౌన్‌లోడ్ బటన్ నొక్కిన次数",
  collect5: "URL ఫిల్టర్, ఫోల్డర్ ప్రీఫిక్స్, ఫైల్ ప్రీఫిక్స్ తప్ప మిగతా సెట్టింగ్స్",
  allow: "ఒకసారి అనామక డేటా సేకరణకు అనుమతించండి",

  title2: "కొన్ని ప్రశ్నలు (ఐచ్ఛికం)",

  browser: "మీ బ్రౌజర్ ఏది?",
  os: "మీ ఆపరేటింగ్ సిస్టమ్ ఏమిటి?",
  Windows_10_or_older: "Windows 10 లేదా పాతది",
  speed: "మీ ఇంటర్నెట్ వేగం ఎంత?",
  Less_than_1_Mbps: "1 Mbps కంటే తక్కువ",
  More_than_100_Mbps: "100 Mbps కంటే ఎక్కువ",
  freq: "మీరు ఎంత తరచుగా ఉపయోగిస్తారు?",
  Daily: "ప్రతిరోజూ",
  Weekly: "ప్రతి వారం",
  Monthly: "ప్రతి నెల",
  Rarely: "అరుదుగా",
  purpose: "మీరు దీన్ని ఎందుకు ఉపయోగిస్తున్నారు?",
  translation: "అనువాద సమస్యలు ఎదుర్కొన్నారా?",
  bugs: "బగ్స్ ఉన్నాయా?",
  improve: "మేము ఏమి మెరుగుపరచాలి?",
  side: "సైడ్ ప్యానెల్ గురించి తెలుసా?",
  convert: "ఇమేజ్ కన్వర్షన్ గురించి తెలుసా?",
  rate: "మాకు రేటింగ్ ఇవ్వండి",
  anything: "ఇంకేమైనా?",

  submit: "సమర్పించండి",

  thanks: "ధన్యవాదాలు",
  done: "మీ అభిప్రాయానికి ధన్యవాదాలు. మీరు ఇన్‌స్టాల్ చేసిన తేదీ",
  pressed: "మరియు డౌన్‌లోడ్ బటన్ నొక్కారు",
  times: "సార్లు.",

  share: "షేర్ చేయండి",
  Share_extension: "ఎక్స్‌టెన్షన్‌ను షేర్ చేయండి",
  Rate_us: "మాకు రేటింగ్ ఇవ్వండి",

  Other: "ఇతరాలు",
  no: "జవాబు ఇవ్వను",
  yes: "అవును",
  no2: "కాదు",
  na: "వర్తించదు"
},

th: {
  step1: "ขั้นตอนที่ 1 จาก 2",
  step2: "ขั้นตอนที่ 2 จาก 2",
  title1: "ช่วยเราปรับปรุงส่วนขยาย",
  desc1:
    "ส่วนขยายของเราไม่เก็บข้อมูลผู้ใช้โดยอัตโนมัติ ช่วยแชร์ข้อมูลทางเทคนิคแบบไม่ระบุตัวตน",
  collect: "ข้อมูลที่เราจะเก็บ:",
  collect1: "UID (รหัสสุ่มตอนติดตั้ง)",
  collect2: "เวอร์ชันของส่วนขยาย",
  collect3: "วันที่ติดตั้ง",
  collect4: "จำนวนครั้งที่กดดาวน์โหลด",
  collect5: "การตั้งค่าที่ยกเว้น URL filter, folder prefix และ file prefix",
  allow: "อนุญาตให้เก็บข้อมูลทางเทคนิคครั้งเดียว",

  title2: "มีคำถามเล็กน้อย (ไม่บังคับ)",

  browser: "คุณใช้เบราว์เซอร์อะไร?",
  os: "คุณใช้ระบบปฏิบัติการอะไร?",
  Windows_10_or_older: "Windows 10 หรือเก่ากว่า",
  speed: "ความเร็วอินเทอร์เน็ตของคุณ?",
  Less_than_1_Mbps: "น้อยกว่า 1 Mbps",
  More_than_100_Mbps: "มากกว่า 100 Mbps",
  freq: "คุณใช้งานบ่อยแค่ไหน?",
  Daily: "ทุกวัน",
  Weekly: "ทุกสัปดาห์",
  Monthly: "ทุกเดือน",
  Rarely: "นาน ๆ ครั้ง",
  purpose: "คุณใช้เพื่ออะไร?",
  translation: "พบปัญหาการแปลหรือไม่?",
  bugs: "พบบั๊กหรือไม่?",
  improve: "ควรปรับปรุงอะไร?",
  side: "คุณรู้เรื่อง side panel หรือไม่?",
  convert: "คุณรู้เรื่องการแปลงรูปภาพหรือไม่?",
  rate: "ให้คะแนนเรา",
  anything: "อย่างอื่นเพิ่มเติม?",

  submit: "ส่งความคิดเห็น",

  thanks: "ขอบคุณ",
  done: "ขอบคุณสำหรับความคิดเห็น คุณติดตั้งเมื่อ",
  pressed: "และกดดาวน์โหลด",
  times: "ครั้ง",

  share: "แชร์ส่วนขยาย",
  Share_extension: "แชร์ส่วนขยาย",
  Rate_us: "ให้คะแนนเรา",

  Other: "อื่น ๆ",
  no: "ไม่ต้องการตอบ",
  yes: "ใช่",
  no2: "ไม่ใช่",
  na: "ไม่ระบุ"
},

tr: {
  step1: "1 / 2. Adım",
  step2: "2 / 2. Adım",
  title1: "Eklentimizi geliştirmemize yardımcı olun",
  desc1:
    "Eklentimiz kullanıcı verisi toplamaz. Anonim teknik veriler paylaşarak yardımcı olun.",
  collect: "Toplayacağımız veriler:",
  collect1: "UID (kurulumda oluşturulan kod)",
  collect2: "Eklenti sürümü",
  collect3: "Kurulum tarihi",
  collect4: "İndirme butonuna basılma sayısı",
  collect5: "URL filtresi, klasör öneki ve dosya öneki hariç ayarlar",
  allow: "Tek seferlik anonim veri toplamaya izin ver",

  title2: "Birkaç soru (isteğe bağlı)",

  browser: "Hangi tarayıcıyı kullanıyorsun?",
  os: "Hangi işletim sistemini kullanıyorsun?",
  Windows_10_or_older: "Windows 10 veya daha eski",
  speed: "İnternet hızın nedir?",
  Less_than_1_Mbps: "1 Mbps’den az",
  More_than_100_Mbps: "100 Mbps’den fazla",
  freq: "Ne sıklıkla kullanıyorsun?",
  Daily: "Her gün",
  Weekly: "Haftalık",
  Monthly: "Aylık",
  Rarely: "Nadiren",
  purpose: "Ne için kullanıyorsun?",
  translation: "Çeviri sorunu yaşadın mı?",
  bugs: "Hata yaşadın mı?",
  improve: "Neyi geliştirebiliriz?",
  side: "Yan paneli biliyor muydun?",
  convert: "Görsel dönüştürmeyi biliyor muydun?",
  rate: "Bizi değerlendir",
  anything: "Başka bir şey?",

  submit: "Gönder",

  thanks: "Teşekkürler",
  done: "Geri bildirimin için teşekkürler. Kurulum tarihi",
  pressed: "ve indirme butonuna bastın",
  times: "kez.",

  share: "Paylaş",
  Share_extension: "Eklentiyi paylaş",
  Rate_us: "Bizi değerlendir",

  Other: "Diğer",
  no: "Cevaplamak istemiyorum",
  yes: "Evet",
  no2: "Hayır",
  na: "Uygulanamaz"
},

uk: {
  step1: "Крок 1 з 2",
  step2: "Крок 2 з 2",
  title1: "Допоможіть покращити наше розширення",
  desc1:
    "Наше розширення не збирає дані автоматично. Допоможіть анонімно поділитися технічними даними.",
  collect: "Що ми збираємо:",
  collect1: "UID (випадковий код під час встановлення)",
  collect2: "Версія розширення",
  collect3: "Дата встановлення",
  collect4: "Кількість натискань кнопки завантаження",
  collect5: "Налаштування без URL-фільтра, префікса папки та файлу",
  allow: "Дозволити одноразовий збір даних",

  title2: "Кілька запитань (необов’язково)",

  browser: "Який у вас браузер?",
  os: "Яка у вас ОС?",
  Windows_10_or_older: "Windows 10 або старіша",
  speed: "Швидкість інтернету?",
  Less_than_1_Mbps: "Менше 1 Mbps",
  More_than_100_Mbps: "Більше 100 Mbps",
  freq: "Як часто використовуєте?",
  Daily: "Щодня",
  Weekly: "Щотижня",
  Monthly: "Щомісяця",
  Rarely: "Рідко",
  purpose: "Для чого використовуєте?",
  translation: "Чи були проблеми з перекладом?",
  bugs: "Чи були помилки?",
  improve: "Що покращити?",
  side: "Чи знали про бічну панель?",
  convert: "Чи знали про конвертацію зображень?",
  rate: "Оцініть нас",
  anything: "Щось ще?",

  submit: "Надіслати",

  thanks: "Дякуємо",
  done: "Дякуємо за відгук. Ви встановили",
  pressed: "і натиснули кнопку завантаження",
  times: "разів.",

  share: "Поділитися",
  Share_extension: "Поділитися розширенням",
  Rate_us: "Оцініть нас",

  Other: "Інше",
  no: "Не хочу відповідати",
  yes: "Так",
  no2: "Ні",
  na: "Не застосовується"
},

vi: {
  step1: "Bước 1 / 2",
  step2: "Bước 2 / 2",
  title1: "Giúp chúng tôi cải thiện tiện ích",
  desc1:
    "Tiện ích không tự động thu thập dữ liệu. Hãy chia sẻ dữ liệu kỹ thuật ẩn danh để giúp chúng tôi.",
  collect: "Chúng tôi thu thập:",
  collect1: "UID (mã ngẫu nhiên khi cài đặt)",
  collect2: "Phiên bản tiện ích",
  collect3: "Ngày cài đặt",
  collect4: "Số lần bấm tải xuống",
  collect5: "Cài đặt trừ URL filter, folder prefix và file prefix",
  allow: "Cho phép thu thập dữ liệu kỹ thuật một lần",

  title2: "Một vài câu hỏi (không bắt buộc)",

  browser: "Bạn dùng trình duyệt nào?",
  os: "Bạn dùng hệ điều hành nào?",
  Windows_10_or_older: "Windows 10 hoặc cũ hơn",
  speed: "Tốc độ internet của bạn?",
  Less_than_1_Mbps: "Dưới 1 Mbps",
  More_than_100_Mbps: "Trên 100 Mbps",
  freq: "Bạn dùng thường xuyên không?",
  Daily: "Hàng ngày",
  Weekly: "Hàng tuần",
  Monthly: "Hàng tháng",
  Rarely: "Hiếm khi",
  purpose: "Bạn dùng để làm gì?",
  translation: "Có lỗi dịch thuật không?",
  bugs: "Có lỗi nào không?",
  improve: "Chúng tôi nên cải thiện gì?",
  side: "Bạn có biết side panel không?",
  convert: "Bạn có biết chuyển đổi ảnh không?",
  rate: "Đánh giá chúng tôi",
  anything: "Thêm gì không?",

  submit: "Gửi",

  thanks: "Cảm ơn",
  done: "Cảm ơn phản hồi của bạn. Bạn đã cài đặt vào",
  pressed: "và đã bấm tải xuống",
  times: "lần.",

  share: "Chia sẻ",
  Share_extension: "Chia sẻ tiện ích",
  Rate_us: "Đánh giá chúng tôi",

  Other: "Khác",
  no: "Không muốn trả lời",
  yes: "Có",
  no2: "Không",
  na: "Không áp dụng"
},

zh_CN: {
  step1: "第 1 / 2 步",
  step2: "第 2 / 2 步",
  title1: "帮助我们改进扩展",
  desc1:
    "我们的扩展不会自动收集用户数据。请匿名分享一些技术数据以帮助我们改进。",
  collect: "我们将收集：",
  collect1: "UID（安装时生成的随机代码）",
  collect2: "扩展版本",
  collect3: "安装日期",
  collect4: "下载按钮点击次数",
  collect5: "除 URL filter、folder prefix 和 file prefix 外的设置",
  allow: "允许一次性匿名技术数据收集",

  title2: "几个问题（可选）",

  browser: "你使用什么浏览器？",
  os: "你使用什么操作系统？",
  Windows_10_or_older: "Windows 10 或更旧",
  speed: "你的网速是多少？",
  Less_than_1_Mbps: "低于 1 Mbps",
  More_than_100_Mbps: "超过 100 Mbps",
  freq: "你使用频率如何？",
  Daily: "每天",
  Weekly: "每周",
  Monthly: "每月",
  Rarely: "很少",
  purpose: "你用它做什么？",
  translation: "是否遇到翻译问题？",
  bugs: "是否遇到 bug？",
  improve: "我们可以改进什么？",
  side: "你知道侧边栏功能吗？",
  convert: "你知道图片转换功能吗？",
  rate: "给我们评分",
  anything: "还有什么想说的吗？",

  submit: "提交反馈",

  thanks: "谢谢",
  done: "感谢你的反馈。你安装于",
  pressed: "并点击下载按钮",
  times: "次。",

  share: "分享扩展",
  Share_extension: "分享扩展",
  Rate_us: "给我们评分",

  Other: "其他",
  no: "不想回答",
  yes: "是",
  no2: "否",
  na: "不适用"
},

zh_TW: {
  step1: "第 1 / 2 步",
  step2: "第 2 / 2 步",
  title1: "幫助我們改進擴充功能",
  desc1:
    "我們的擴充功能不會自動收集使用者資料。請匿名分享技術資料以幫助我們改進。",
  collect: "我們將收集：",
  collect1: "UID（安裝時生成的隨機代碼）",
  collect2: "擴充功能版本",
  collect3: "安裝日期",
  collect4: "下載按鈕點擊次數",
  collect5: "不含 URL filter、folder prefix、file prefix 的設定",
  allow: "允許一次性匿名技術資料收集",

  title2: "幾個問題（可選）",

  browser: "你使用什麼瀏覽器？",
  os: "你使用什麼作業系統？",
  Windows_10_or_older: "Windows 10 或更舊",
  speed: "你的網路速度？",
  Less_than_1_Mbps: "低於 1 Mbps",
  More_than_100_Mbps: "超過 100 Mbps",
  freq: "使用頻率？",
  Daily: "每天",
  Weekly: "每週",
  Monthly: "每月",
  Rarely: "很少",
  purpose: "你用來做什麼？",
  translation: "是否遇到翻譯問題？",
  bugs: "是否遇到錯誤？",
  improve: "我們可以改進什麼？",
  side: "你知道側邊欄功能嗎？",
  convert: "你知道圖片轉換功能嗎？",
  rate: "給我們評分",
  anything: "還有什麼想說的？",

  submit: "提交回饋",

  thanks: "謝謝",
  done: "感謝你的回饋。你安裝於",
  pressed: "並點擊下載按鈕",
  times: "次。",

  share: "分享擴充功能",
  Share_extension: "分享擴充功能",
  Rate_us: "給我們評分",

  Other: "其他",
  no: "不想回答",
  yes: "是",
  no2: "否",
  na: "不適用"
}
}